// extracted by mini-css-extract-plugin
module.exports = {"content":"banner_content__2oyx_","bg":"banner_bg__myleN","parallelogramSpan":"banner_parallelogramSpan__13iKB","title":"banner_title__8MFBO"};